import { Button } from "@aircall/ds";
import { useToast } from "@dashboard/library";
import { useTranslation } from "react-i18next";

import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle";

// The publish mutation can return an error union whose `message` is empty. The
// critical toast then renders with no text — just the variant icon and the
// close icon (what Nora screenshotted). The fix falls back to a generic string.
const EMPTY_API_MESSAGE = "";
const DISMISS_IN = 60_000;

export function PlaygroundReviewToast() {
  const { show } = useToast();
  const { t } = useTranslation();

  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Scorecard publish error toast
        </PlaygroundSubSectionTitle>
        <div className="flex flex-col gap-3">
          <Button
            variant="secondary"
            data-test="toast-before"
            onClick={() =>
              show({
                variant: "critical",
                message: EMPTY_API_MESSAGE,
                dismissIn: DISMISS_IN,
              })
            }
          >
            Before: empty API message (icon-only toast)
          </Button>
          <Button
            variant="secondary"
            data-test="toast-after"
            onClick={() =>
              show({
                variant: "critical",
                message: EMPTY_API_MESSAGE || t("error.generic.title"),
                dismissIn: DISMISS_IN,
              })
            }
          >
            After: falls back to a generic message
          </Button>
        </div>
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
